import images from '../../../static/images/RealtorLanding/RealtorsLogos';

export const TOP_LOGOS = [
    images.victory,
    images.theRightWay,
    images.stockbroker,
    images.samariaRealEstate,
    images.requires,
    images.replace,
    images.remax,
    images.reich,
    images.realeStateDolutions,
    images.realEstateWell,
    images.realEstateSolutions,
    images.quickRealEstate,
    images.provence,
    images.maxHome,
    images.homeland,
    images.homeInIsrael
];
export const BOTTOM_LOGOS = [
    images.hmInvest,
    images.govAri,
    images.goldmanRealEstate,
    images.goReality,
    images.friendshipFoundation,
    images.franzi,
    images.fiveRealEstateConsultants,
    images.firstRealEstate,
    images.eranDrori,
    images.elios,
    images.claireWilliams,
    images.apartmentsFirst,
    images.angloSaxon,
    images.group
];

export const SETTINGS = {
    loop: true,
    slidesPerView: 8,
    spaceBetween: 30,
    loopedSlides: TOP_LOGOS.length,
    loopFillGroupWithBlank: false,
    centeredSlides: false,
    breakpoints: {
        1656: {
            slidesPerView: 6
        },
        1400: {
            slidesPerView: 5
        },
        1200: {
            slidesPerView: 4
        },
        804: {
            slidesPerView: 3
        },
        460: {
            slidesPerView: 2
        }
    }
};
